import React, { useState } from 'react';
import { Card, Button, Form } from "tabler-react";
import { useForm } from '../../lib/useForm';
import postObject from '../../lib/postObject';
import ImageUpload from '../../components/imageUpload';

const UserCreateModal = ({ closeMainModal, reload }) => {
  const [user, handleChange] = useForm({ firstName: '', lastName: '', email: '', password: '' });
  const [photo, setPhoto] = useState('');
  const [saveLoading, setSaveLoading] = useState(false);
  const [error, setError] = useState('');

  const validateForm = () => {
    if (!user.firstName || !user.lastName || !user.email || !user.password) {
      setError('Please fill in all required fields');
      return false;
    }
    return true;
  };

  const saveUser = async () => {
    setError('');
    if (!validateForm()) return;

    try {
      setSaveLoading(true);
      const payload = { ...user };
      if (photo) payload.photo = photo;
      await postObject('users', payload);
      if (typeof reload === 'function') {
        reload();
      }
      closeMainModal();
    } catch (err) {
      setError('Failed to create user. Please try again.');
    } finally {
      setSaveLoading(false);
    }
  };

  return (
    <Card>
      <Card.Header>
        <Card.Title>Create User</Card.Title>
        <Card.Options>
          <Button
            size="sm"
            icon="x"
            onClick={closeMainModal}
          />
        </Card.Options>
      </Card.Header>
      <Card.Body>
        {error && <div className="alert alert-danger">{error}</div>}
        <Form onSubmit={(e) => { e.preventDefault(); saveUser(); }}>
          <Form.Input
            name="firstName"
            label="First Name"
            placeholder="Enter first name"
            value={user.firstName}
            onChange={handleChange}
            required
          />

          <Form.Input
            name="lastName"
            label="Last Name"
            placeholder="Enter last name"
            value={user.lastName}
            onChange={handleChange}
            required
          />

          <Form.Input
            name="password"
            label="Password"
            placeholder="Enter password"
            type="password"
            value={user.password}
            onChange={handleChange}
            required
          />

          <Form.Input
            name="email"
            label="E-mail"
            placeholder="Enter email"
            type="email"
            value={user.email}
            onChange={handleChange}
            required
          />

          <ImageUpload
            label="Photo (Optional)"
            uploadText="Click here to upload photo"
            alt="User Preview"
            onChange={(value) => setPhoto(value)}
          />
        </Form>
      </Card.Body>
      <Card.Footer>
        <div style={{ textAlign: 'right' }}>
          <Button
            color="primary"
            size="sm"
            className={`ml-2 ${saveLoading ? 'btn-loading' : ''}`}
            onClick={saveUser}
            disabled={saveLoading}
          >
            Save
          </Button>
          <Button
            color="secondary"
            size="sm"
            className="ml-2"
            onClick={closeMainModal}
            disabled={saveLoading}
          >
            Cancel
          </Button>
        </div>
      </Card.Footer>
    </Card>
  );
};

export default UserCreateModal;
